export const CURRENT_DATE = new Date().toISOString()
    .split("T")[0].toString();
    
